import "lenis/dist/lenis.css";

import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initGsapLenis() {
    const lenis = new Lenis({
        content: document.querySelector("#smooth-content"),
        anchors: {
            offset: -APP_NAVBAR_HEIGHT,
        },
        prevent: (node) => node.classList.contains("iti__country-list"),
    });

    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
}
